import React, { FC, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Box, Tabs, Tab, Button } from '@material-ui/core';
import { RootState } from '../../store/configureStore';
import * as AnalyticsActions from '../../actions/Analytics/actions';
import { MeasurementFilter } from '../../constants/Analytics';
import FilterPanel from '../../components/Analytics/FilterPanel';
import MeasurementListTab from '../../components/Analytics/MeasurementListTab';
import DistributionTab from '../../components/Analytics/DistributionTab';
import Loading from '../../components/common/Loading';
import BackButton from '../../components/common/BackButton';

const AnalyticsContainer: FC = () => {
  const dispatch = useDispatch();
  const filters = useSelector((s: RootState) => s.analytics.filters);
  const filterLoaded = useSelector((s: RootState) => s.analytics.filterLoaded);
  const error = useSelector((s: RootState) => s.analytics.error);
  const [tab, setTab] = useState(0);
  const [activeFilter, setActiveFilter] = useState<MeasurementFilter | null>(null);

  useEffect(() => {
    if (!filterLoaded) {
      dispatch(AnalyticsActions.getFilters());
    }
  }, [filterLoaded, dispatch]);

  const onSearch = (f: MeasurementFilter) => {
    setActiveFilter(f);
    dispatch(AnalyticsActions.setFilter(f));
    dispatch(AnalyticsActions.searchMeasurements(f, 1));
  };

  if (!filterLoaded && error) {
    return (
      <Container>
        <BackButton />
        <Box my={2} fontSize={28} fontWeight="fontWeightBold">
          データ分析
        </Box>
        <Box my={2} color="error.main">
          フィルタの読み込みに失敗しました。
        </Box>
        <Button color="primary" variant="outlined" onClick={() => dispatch(AnalyticsActions.getFilters())}>
          再読み込み
        </Button>
      </Container>
    );
  }

  if (!filterLoaded || !filters) {
    return <Loading />;
  }

  return (
    <Container>
      <BackButton />
      <Box my={2} fontSize={28} fontWeight="fontWeightBold">
        データ分析
      </Box>
      <FilterPanel filters={filters} onSearch={onSearch} />
      {error && (
        <Box mt={1} color="error.main">
          エラーが発生しました。時間をおいて再度お試しください。
        </Box>
      )}
      <Tabs value={tab} onChange={(_, v) => setTab(v)} indicatorColor="primary" textColor="primary">
        <Tab label="測定一覧" />
        <Tab label="分布" />
      </Tabs>
      {activeFilter ? (
        <Box mt={2}>
          {tab === 0 && <MeasurementListTab filter={activeFilter} />}
          {tab === 1 && <DistributionTab filter={activeFilter} />}
        </Box>
      ) : (
        <Box mt={2}>条件を指定して「検索」を押してください。</Box>
      )}
    </Container>
  );
};

export default AnalyticsContainer;
